export default function(doc: AnyDocument): string | null {
  if ((<RasterDocument> doc).rasterUrl) {
    return (<RasterDocument> doc).rasterUrl;
  } else if ((<ReportDocument> doc).downloadUrl) {
    return (<ReportDocument> doc).downloadUrl;
  } else if ((<YieldAnalysisDocument> doc).rasterUrl) {
    return (<YieldAnalysisDocument> doc).rasterUrl;
  } else if ((<ZoneAnalysisDocument> doc).rasterUrl) {
    return (<ZoneAnalysisDocument> doc).rasterUrl;
  } else {
    return null;
  }
}



// WEBPACK FOOTER //
// ./src/utils/inferDocDownloadUrl.ts